import { Link } from "react-router-dom";
import { Check, X, Star } from "lucide-react";
import { PLATFORMS, MATRIX_ROWS } from "../../data/platforms";
import { FadeUp } from "./Reveal";

const Cell = ({ row, p }) => {
  if (row.bool) {
    const v = p.matrix[row.key];
    return v
      ? <Check className="mx-auto h-4 w-4 text-volt" strokeWidth={3} />
      : <X className="mx-auto h-4 w-4 text-white/20" />;
  }
  return <span className="text-sm text-white/75">{row.render(p)}</span>;
};

const ComparisonMatrix = () => (
  <FadeUp className="overflow-x-auto rounded-2xl border border-white/[0.06]" data-testid="comparison-matrix">
    <div className="min-w-[860px]">
      <div className="grid grid-cols-6 bg-cardink">
        <div className="p-5"><span className="overline-label">2026 Matrix</span></div>
        {PLATFORMS.map((p) => (
          <div key={p.slug} className="flex flex-col items-center gap-1.5 border-l border-white/5 p-5 text-center">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg font-display text-xs font-extrabold" style={{ backgroundColor: `${p.hue}1f`, color: p.hue }}>
              {p.monogram}
            </span>
            <span className="font-display text-sm font-bold">{p.name}</span>
            <span className="flex items-center gap-1 text-xs text-white/50">
              <Star className="h-3 w-3 fill-volt text-volt" /> {p.rating}
            </span>
          </div>
        ))}
      </div>
      {MATRIX_ROWS.map((row) => (
        <div key={row.key} className="grid grid-cols-6 border-t border-white/5 transition-colors hover:bg-white/[0.03]">
          <div className="p-4 text-sm font-medium text-white/85">{row.label}</div>
          {PLATFORMS.map((p) => (
            <div key={p.slug} className="flex items-center justify-center border-l border-white/5 p-4 text-center">
              <Cell row={row} p={p} />
            </div>
          ))}
        </div>
      ))}
      <div className="grid grid-cols-6 border-t border-white/5 bg-cardink/60">
        <div className="p-4" />
        {PLATFORMS.map((p) => (
          <div key={p.slug} className="flex flex-col items-center gap-2 border-l border-white/5 p-4">
            <a href={p.affiliateUrl} target="_blank" rel="noopener noreferrer sponsored" data-testid={`matrix-cta-${p.slug}`} className="rounded-full bg-volt px-4 py-1.5 text-xs font-bold text-ink transition-colors hover:bg-volt-hover">
              Try Free
            </a>
            <Link to={`/reviews/${p.slug}`} data-testid={`matrix-review-${p.slug}`} className="text-xs text-white/50 underline-offset-2 transition-colors hover:text-volt hover:underline">
              Read review
            </Link>
          </div>
        ))}
      </div>
    </div>
  </FadeUp>
);

export default ComparisonMatrix;
